<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getExternalCustomerUserTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>
        <Card
            :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">外部客户账户列表</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreateExternalCustomerUser">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :extHeight="60"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getExternalCustomerUserTableRecords" />
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { getCustomerSearchList } from '@/api/modules/account-management/externalCustomer-user-management';

export default {
    name: 'ExternalCustomerUserList',
    components: {
        SearchCard,
        StandPaginationTable
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    { title: '会员号', key: 'userName', align: 'center' },
                    { title: '申请人', key: 'userExternalCustomerName', align: 'center' },
                    { title: '手机号码', key: 'userExternalCustomerPhone', align: 'center' },
                    { title: '客户经理', key: 'userCustomerManagerName', width: 80, align: 'center' },
                    { title: '创建时间', key: 'userExternalCustomerCreateAt', width: 180, align: 'center', render: (h, params) => dateTimeRender(h, params.row.userExternalCustomerCreateAt) }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '会员号', type: 'Input', value: '', name: 'userName', sql: 'like' },
                    { label: '手机号码', type: 'Input', value: '', name: 'userExternalCustomerPhone', sql: 'like' },
                    { label: '姓名', type: 'Input', value: '', name: 'userExternalCustomerName', sql: 'like' },
                    { label: '收货地址', type: 'Input', value: '', name: 'userExternalCustomerFullAddress', sql: 'like' }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    created() {
        if (this.readOnly) {
            const findIndex = this.mainTable.columns.findIndex(c => c.title === "操作");
            if (findIndex >= 0) {
                this.mainTable.columns.splice(findIndex, 1);
            }
        }
    },
    methods: {
        getExternalCustomerUserTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
			
            search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
            this.mainTable.tableSearch.filters.enable = true;
            this.mainTable.tableSearch.filters.conditions.push({
                name: 'memberType',
                type: 'eq',
                value: 'F'
            });
            getCustomerSearchList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
